import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

export const getSafeRedirectURL = redirectRoute => {
  if (!redirectRoute || typeof redirectRoute !== 'string') {
    return '';
  }

  const trimmedRoute = redirectRoute.trim();
  if (!trimmedRoute) {
    return '';
  }

  let decodedRoute = trimmedRoute;
  try {
    decodedRoute = decodeURIComponent(trimmedRoute);
  } catch (error) {
    // Ignore invalid URI sequences, use the raw string
  }

  // Reject absolute URLs, schemes, and protocol-relative URLs
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(decodedRoute)) {
    return '';
  }

  if (decodedRoute.startsWith('//')) {
    return '';
  }

  let candidateRoute = decodedRoute;

  // Normalize to an app-scoped path
  if (candidateRoute === 'app' || candidateRoute === '/app') {
    candidateRoute = '/app/';
  } else if (candidateRoute.startsWith('/app')) {
    // keep as-is
  } else if (candidateRoute.startsWith('app/')) {
    candidateRoute = `/${candidateRoute}`;
  } else if (candidateRoute.startsWith('/')) {
    candidateRoute = `/app${candidateRoute}`;
  } else {
    candidateRoute = `/app/${candidateRoute}`;
  }

  const base = 'https://chatwoot.invalid';

  try {
    const url = new URL(candidateRoute, base);
    if (url.origin !== base) {
      return '';
    }

    if (url.pathname === '/app') {
      return `/app/${url.search}${url.hash}`;
    }

    if (!url.pathname.startsWith('/app/')) {
      return '';
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return '';
  }
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

export const getLoginRedirectURL = ({
  redirectRoute,
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const safeRedirectURL = getSafeRedirectURL(redirectRoute);
  if (safeRedirectURL) {
    return safeRedirectURL;
  }

  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
